// extracted by mini-css-extract-plugin
export default {"view":"EmptyView_view__YJiDb","icon":"EmptyView_icon__UyJ2b"};